export default {
  // header
  'dashboard.events.header.select.seller': 'Seller',

  // list
  'dashboard.events.list.header.calendar.switch': 'Weekends',
  'dashboard.events.list.header.add.event.button': 'Add event',
};
